import React from 'react';

import { useLocale } from '@adsk/alloy-react-locale';

import { ItemButton } from './styles';

/**
 * Displays an error message and a retry button.
 *
 * @param expandNodeFailureText - The text to display when the node fails to load.
 * @param retryButtonText - The text to display on the retry button.
 * @param onRetry - The function to call when the retry button is clicked.
 */
const ErrorNode = ({
  expandNodeFailureText,
  retryButtonText,
  onRetry
}: {
  expandNodeFailureText?: React.ReactNode;
  retryButtonText?: React.ReactNode;
  onRetry: () => void;
}) => {
  const { T } = useLocale(({ locale }) => require(`../locale/${locale}.json`));
  return (
    <>
      {expandNodeFailureText}
      <ItemButton data-testid="retry-button" underline="none" onClick={onRetry}>
        {retryButtonText || T.translate('retryButtonText')}
      </ItemButton>
    </>
  );
};

ErrorNode.displayName = 'ErrorNode';

export default ErrorNode;
